<div class="playbook__title" (click)="onClick()" tabindex="0">
  <mat-icon [svgIcon]="AppIcon.BOOK_CIRCLE" class="playbook__title-icon"></mat-icon>
  <span>{{ PAGE_KEY + 'PLAYBOOK' | translate }}</span>
</div>
